import React, { useCallback, useEffect } from 'react';
import i18n from 'i18next';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import useAgent from '../../../common/hooks/useAgent';
import clientAgent from '../../agents/clientAgent';
import ClientCreationForm from '../form/ClientCreationForm';
import { Container } from '../../../common/components/layout';

const ClientCreation = ({ onBackClick, onCreatedSuccess }) => {
  const [createClient, createdClient] = useAgent(clientAgent.createClient);

  useEffect(() => {
    if (createdClient) {
      toast.success(i18n.t('client.message.creationSuccess'));
      onCreatedSuccess(createdClient.id);
    }
  }, [createdClient, onCreatedSuccess]);

  const handleSubmit = useCallback((values) => createClient(values), [createClient]);

  return (
    <Container>
      <ClientCreationForm onBackClick={onBackClick} onSubmit={handleSubmit} />
    </Container>
  );
};

ClientCreation.propTypes = {
  onBackClick: PropTypes.func,
  onCreatedSuccess: PropTypes.func,
};

ClientCreation.defaultProps = {
  onBackClick: undefined,
  onCreatedSuccess: undefined,
};
export default ClientCreation;
